package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.ui.components.TabChip
import ru.chm.gradereport.ui.components.formatDisplayDate
import ru.chm.gradereport.ui.components.horizontalScrollOnWheel
import ru.chm.gradereport.ui.theme.GradeTheme

internal enum class SessionSortOrder {
    NewestFirst,
    OldestFirst,
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun SheetViewControls(
    sortOrder: SessionSortOrder,
    onSortOrderChange: (SessionSortOrder) -> Unit,
    dates: List<String>,
    focusDate: String?,
    onFocusDateChange: (String?) -> Unit,
) {
    val colors = GradeTheme.colors
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 10.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        Text(
            "Порядок занятий",
            color = colors.textMuted,
            fontSize = 13.sp,
            fontWeight = FontWeight.Medium,
        )
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            TabChip(
                text = "Сначала новые",
                selected = sortOrder == SessionSortOrder.NewestFirst,
                onClick = { onSortOrderChange(SessionSortOrder.NewestFirst) },
            )
            TabChip(
                text = "Сначала старые",
                selected = sortOrder == SessionSortOrder.OldestFirst,
                onClick = { onSortOrderChange(SessionSortOrder.OldestFirst) },
            )
        }

        if (dates.isNotEmpty()) {
            Text(
                "Дата",
                color = colors.textMuted,
                fontSize = 13.sp,
                fontWeight = FontWeight.Medium,
            )
            val datesScroll = rememberScrollState()
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .horizontalScroll(datesScroll)
                    .horizontalScrollOnWheel(datesScroll),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                TabChip(
                    text = "Все даты",
                    selected = focusDate == null,
                    onClick = { onFocusDateChange(null) },
                )
                dates.forEach { date ->
                    TabChip(
                        text = formatDisplayDate(date),
                        selected = focusDate == date,
                        onClick = { onFocusDateChange(date) },
                    )
                }
            }
        }
    }
}
